// Service responsável por comunicação HTTP (axios) deste domínio
import axios from '@axios'
import endpoints from './endpoints'

export default {
  // Busca paginada com filtros
  getPaginado(page, pageSize, filtros) {
    return axios.post(endpoints.paged(page, pageSize), filtros)
  },

  // Consulta apuração por empresas
  getApuracaoMitEmpresa(empresasFiltro) {
    return axios.post(endpoints.consultarApuracaoEmpresa, empresasFiltro)
  },

  // Consulta apuração por mês/ano (mesmo endpoint)
  getApuracaoMitMesAno(empresasFiltro) {
    return axios.post(endpoints.consultarApuracaoMesAno, empresasFiltro)
  },

  // Ajuste: valores de débitos via POST com paginação e filtro no body
  getDebitosValores(pagina, tamanhoPagina, filtro) {
    return axios.post(endpoints.debitosValores(pagina, tamanhoPagina), filtro)
  },

  // Busca débitos de encerramento via POST com paginação e filtro no body
  getDebitosEncerramento(pagina, tamanhoPagina, filtro) {
    // Método para consumir o endpoint HttpPost("debitos/encerramento")
    return axios.post(endpoints.debitosEncerramento(pagina, tamanhoPagina), filtro)
  },

  // Busca suspensões via POST com paginação e filtro no body
  getSuspensoes(pagina, tamanhoPagina, filtro) {
    // Método para consumir o endpoint HttpPost("suspensoes")
    return axios.post(endpoints.suspensoes(pagina, tamanhoPagina), filtro)
  },
}
